/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
import imagesLoaded from 'imagesloaded';
import Cursor from "./modules/cursor";
import Magnetic from "./modules/magnetic";
import { mobileNav } from './modules/mobileNav';
import { stickyNav } from './modules/stickyNav';
import { popupVideo } from './modules/popupVideo';
import { homeHeroVideo } from './modules/homeHeroVideo';
import { homeHeroSlider } from './modules/homeHeroSlider';

// Nav
if ($('body').hasClass('scrolled')) {
  $('.mainNav__listItem--shop').on("mouseenter", function () {
    $("body").addClass("scrolled");
  }).on('mouseleave', function () {
    // $("body").removeClass("scrolled");
  });
} else {
  $('.mainNav__listItem--shop').on("mouseenter", function () {
    $("body").addClass("scrolled");
  }).on('mouseleave', function () {
    $("body").removeClass("scrolled");
  });
}





// Check for announcement bar
if ($('.announcement-bar__message').length) {
  $("body").addClass("announcement-bar-active");
}

// Don't load on mobile
function is_touch_enabled() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

// Mobile vs. Desktop controls
if (!is_touch_enabled()) {

  // Set up cursor
  const cursor = new Cursor();
  $('[data-magnetic]').each(function () { new Magnetic(this); });

  // Set up scroller on home page
  var onHomePage = document.querySelector('.template-index,.template-page-our-story');
  if (onHomePage) {
    let smoother = ScrollSmoother.create({
      smooth: 1,
      effects: true,
      // smoothTouch: 0.1,
      normalizeScroll: true
    });

    gsap.utils.toArray(".anchor").forEach(function (button, i) {
      button.addEventListener("click", (e) => {
        var id = e.target.getAttribute("href");
        smoother.scrollTo(id, true, "top top");
        e.preventDefault();
      });
    });

    let urlHash = window.location.href.split("#")[1];
    let scrollElem = document.querySelector("#" + urlHash);

    if (urlHash && scrollElem) {
      gsap.to(smoother, {
        scrollTop: smoother.offset(scrollElem, "top top"),
        duration: 0.5
      });
    }

    $('.stories__slideNav').on('click tap', function () {
      smoother.scrollTo('.stories--inner', true, "top top");
    });
  }

} else {
  $('body').addClass('touch');
}

var heroVideoExists = document.getElementById('homeHero__bRoll');
if (heroVideoExists) {
  homeHeroVideo();
}

var heroSliderExists = document.querySelector('.homeHero__slider');
if (heroSliderExists) {
  // alert('firing');
  homeHeroSlider();
}

// Wait for images to load
imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
  // Load stuff after all the images in the body load
  $('body').addClass('ready');
});

if (window.innerWidth > 960) {
  // Hide nav on scroll down
  const showAnim = gsap.from('.siteHeader', {
    yPercent: -100,
    paused: true,
    duration: 0.2
  }).progress(1);

  ScrollTrigger.create({
    // scroller: smoother,
    start: "top top",
    end: 99999,
    onUpdate: (self) => {
      self.direction === -1 ? showAnim.play() : showAnim.reverse()
    }
  });
}

// Site-Wide Functions
popupVideo();
mobileNav();
stickyNav();


// Home page specific functions
import { heroLoadAnimationSimpler } from './modules/heroLoadAnimation';
var heroLoadAnimationExists = document.querySelector('.homeHero');
if (heroLoadAnimationExists) {
  imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
    heroLoadAnimationSimpler();
  });
}

import { brandVideosSlider } from './modules/brandVideosSlider';
var brandVideosSliderExists = document.querySelector('.brandVideos__slider');
if (brandVideosSliderExists) {
  imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
    brandVideosSlider();
  });
}

import { storiesSlider } from './modules/storiesSlider';
var storiesSliderExists = document.querySelector('.stories__slider');
if (storiesSliderExists) {
  imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
    storiesSlider();
  });
}

import { techSlider } from './modules/techSlider';
var techSliderExists = document.querySelector('.tech__slider');
if (techSliderExists) {
  techSlider();
}

import { articlesSlider } from './modules/articlesSlider';
var articlesSliderExists = document.querySelector('.articles__slider');
if (articlesSliderExists) {
  imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
    articlesSlider();
  });
}

import { bundlesSlider } from './modules/bundlesSlider';
var bundlesSliderExists = document.querySelector('.bundles__slider');
if (bundlesSliderExists) {
  bundlesSlider();
}

import { bundleAccordion } from './modules/bundleAccordion';
if (document.querySelector('.bundle-row')) {
  bundleAccordion();
}

// Update cart count on AJAX cart changes
if (typeof subscribe === 'function') {
  subscribe('cart-update', function () {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEl = document.querySelector('.mainNav__cartCount');
        if (cart.item_count > 0) {
          if (!countEl) {
            var cartLink = document.getElementById('cart-icon-bubble-nav');
            if (cartLink) {
              countEl = document.createElement('span');
              countEl.className = 'mainNav__cartCount';
              cartLink.appendChild(countEl);
            }
          }
          if (countEl) countEl.textContent = cart.item_count;
        } else if (countEl) {
          countEl.remove();
        }
      });
  });
}

import { stickyGallery } from './modules/stickyGallery';
var stickyGalleryExists = document.querySelector('.scrollGallery');
if (stickyGalleryExists) {
  imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
    setTimeout(() => {
      stickyGallery();
    }, 1000);
  });
}

// Build Table page specific functions
import { buildTableLoadAnimation } from './modules/buildTableLoadAnimation';
var buildTableLoadAnimationExists = document.querySelector('.buildHero__title');
if (buildTableLoadAnimationExists) {
  imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
    buildTableLoadAnimation();
  });

  $('.tableOptions__color').on('click tap', function () {
    $('.tableOptions__color').removeClass('selected');
    $(this).addClass('selected');
  });

  $('.attachmentOptions__listItem').on('click tap', function () {
    $(this).toggleClass('selected');
  });
}

// Story page
import { storyScroll } from './modules/storyScroll';
var storyScrollExists = document.querySelector('.story__section');
if (storyScrollExists) {
  storyScroll();
}

// Support page
import { support } from './modules/support';
var supportExists = document.querySelector('.template-page-support');
if (supportExists) {
  support();
}

import { faqs } from './modules/toggle';
var faqsExist = document.querySelector('.faq,.toggles');
if (faqsExist) {
  faqs();
}

// Product page
import { gallerySlider } from './modules/gallerySlider';
var gallerySliderExists = document.querySelector('.gallery__slider');
if (gallerySliderExists) {
  gallerySlider();
}

import { questionsSlider } from './modules/questionsSlider';
var questionsSliderExists = document.querySelector('.questions__slider');
if (questionsSliderExists) {
  questionsSlider();
}

import { proPageSliders } from './modules/proPageSliders';
var proPageExists = document.querySelector('.proPro__collageGrid, .proPro__qaGrid');
if (proPageExists) {
  proPageSliders();
}

$('.product__variant').on('click tap', function () {
  $('.product__variant').removeClass('selected');
  $(this).addClass('selected');
});

// Support page
import { supportNavSlider } from './modules/supportNavSlider';
var supportNavSliderExists = document.querySelector('.supportNav__wrap');
if (supportNavSliderExists) {
  supportNavSlider();
}

// Form
import { contactForm } from './modules/contactForm';
var contactFormExists = document.querySelector('.form__label');
if (contactFormExists) {
  contactForm();
}

// Field Notes page
import { featuredNotesSlider } from './modules/featuredNotesSlider';
var featuredNotesSliderExists = document.querySelector('.featuredNotes__slider');
if (featuredNotesSliderExists) {
  featuredNotesSlider();

  $('.notesNav__filter').on('click tap', function () {
    $('.notesNav__filter').removeClass('selected');
    $(this).addClass('selected');
  });
}

// Animate On Scroll
import { animateOnScroll } from './modules/animateOnScroll.js';
imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
  animateOnScroll();
});

$('.tableFeatures__target').on('click tap', function () {
  if ($(this).hasClass("active")) {
    $('.tableFeatures__target').removeClass('active');
  } else {
    $('.tableFeatures__target').removeClass('active');
    $(this).toggleClass('active');
  }
});

// $('.description__readMore').on('click tap', function () {
//   $(this).hide()
//   $('.description__toggle').slideDown();
// });

// $('.description__readLess').on('click tap', function () {
//   $('.description__toggle').slideUp();
//   $('.description__readMore').show();
// });


// Refire stuff on window resize
var timeout = false, // holder for timeout id
  delay = 250; // delay after event is "complete" to run callback

// window.resize event listener
window.addEventListener('resize', function () {
  // clear the timeout
  clearTimeout(timeout);
  // start timing for event "completion"
  timeout = setTimeout(function () {
    ScrollTrigger.refresh();

    // if (heroLoadAnimationExists) {
    //   heroLoadAnimationSimpler();
    // }

    if (stickyGalleryExists) {
      // stickyGallery();
      smoother.effects('.scrollGallery__image');
    }
  }, delay);
});

// document.querySelectorAll('.attachment-form').forEach((attachment) => {
//   attachment.addEventListener('submit', async (e) => {
//     e.preventDefault();

//     // Submit via ajax
//     await fetch('/cart/add', {
//       method: "post",
//       body: new FormData(attachment)
//     });

//     // Update Cart
//     await updateCartDrawer();

//     // alert('firing');
//     // Open cart drawer
//     document.querySelector('.drawer').classList.add('active');

//   });
// });

// // Update cart
// async function updateCartDrawer() {
//   const res = await fetch('/?section_id=cart-drawer');
//   const text = await res.text();

//   const html = document.createElement('div');
//   html.innerHTML = text;
//   const newBox = html.querySelector('.cart-drawer').innerHTML;
//   document.querySelector('.cart-drawer').innerHTML = newBox;

//   console.log(html);
// }

// Table Features
$('.tableFeatures__navItem').on('click tap', function () {
  var target = $(this).attr('data-product-target');
  // alert(target);
  $('.tableFeatures__navItem').removeClass('active');
  $(this).addClass('active');

  $('.tableFeatures__container').removeClass('active');
  $('.tableFeatures__container[data-product-id=' + target + ']').addClass('active');

  $('.tableFeatures__navButtons .button').removeClass('active');
  $('.tableFeatures__navButtons .button[data-button-id=' + target + ']').addClass('active');
});

function palomaFeatures() {
  $('.palomaFeatures__navItem').on('click tap', function () {
    var target = $(this).attr('data-product-target');
    // alert(target);
    $('.palomaFeatures__navItem').removeClass('active');
    $(this).addClass('active');

    $('.palomaFeatures__container').removeClass('active');
    $('.palomaFeatures__container[data-product-id=' + target + ']').addClass('active');

    $('.palomaFeatures__navButtons .button').removeClass('active');
    $('.palomaFeatures__navButtons .button[data-button-id=' + target + ']').addClass('active');
  });

  $('.palomaFeatures__target').on('click tap', function () {
    if ($(this).hasClass("active")) {
      $('.palomaFeatures__target').removeClass('active');
    } else {
      $('.palomaFeatures__target').removeClass('active');
      $(this).toggleClass('active');
    }
  });
}

function palomaVariants() {
  // first, check for a URL param and show the right variant info
  const queryString = window.location.search;
  if (queryString) {
    const urlParams = new URLSearchParams(queryString);
    const variantID = urlParams.get('variant');
    $('.moreProductInfo').hide();
    $('.moreProductInfo[data-variant-id=' + variantID + ']').show();
    $('.custom-description').removeClass('active');
    $('.custom-description[data-variant-id=' + variantID + ']').addClass('active');

    if ((variantID == '47963035009229') || variantID == '') {
      $('.paloma-savings').text("You're Saving $40 with the bundle!");
    } else if (variantID == '47963035041997') {
      $('.paloma-savings').text('Bundle with the Hyde and save!');
    } else {
      $('.paloma-savings').text('Bundle with the Paloma and save!');
    }
  }

  $('.variantOption__input').on('click tap', function () {
    var targetVariant = $(this).attr('data-variant-id');
    $('.moreProductInfo').hide();
    $('.moreProductInfo[data-variant-id=' + targetVariant + ']').show();
    $('.product__title h1').text($(this).val())
    $('.custom-description').removeClass('active');
    $('.custom-description[data-variant-id=' + targetVariant + ']').addClass('active');

    if ((targetVariant == '47963035009229') || (targetVariant == '')) {
      $('.paloma-savings').text("You're Saving $40 with the bundle!");
    } else if (targetVariant == '47963035041997') {
      $('.paloma-savings').text('Bundle with the Hyde and save!');
    } else {
      $('.paloma-savings').text('Bundle with the Paloma and save!');
    }
  });
}

if (window.innerWidth < 768) {
  gsap.to('.palomaFeatures__palomaTop', {
    scrollTrigger: {
      trigger: ".palomaFeatures__title",
      scrub: 1,
      start: 'top 35%',
      end: 'top 20%',
      // markers: true,
    },
    y: "42px"
  });
} else if ((window.innerWidth > 767) && (window.innerWidth < 960)) {
  gsap.to('.palomaFeatures__palomaTop', {
    scrollTrigger: {
      trigger: ".palomaFeatures__title",
      scrub: 1,
      start: 'top 35%',
      end: 'top 20%',
      // markers: true,
    },
    y: "61px"
  });
} else if ((window.innerWidth > 960) && (window.innerWidth < 1400)) {
  gsap.to('.palomaFeatures__palomaTop', {
    scrollTrigger: {
      trigger: ".palomaFeatures__title",
      scrub: 1,
      start: 'top 35%',
      end: 'top 20%',
      // markers: true,
    },
    y: "77px"
  });
} else {
  gsap.to('.palomaFeatures__palomaTop', {
    scrollTrigger: {
      trigger: ".palomaFeatures__title",
      scrub: 1,
      start: 'top 50%',
      end: 'top 30%',
      // markers: true,
    },
    y: "77px"
  });
}

var palomaPage = document.querySelector('.template-product-paloma');
if (palomaPage) {
  palomaFeatures();
  palomaVariants();
}
